/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import Hero from 'components/shared/Hero'
import Breadcrumb from 'components/shared/Breadcrumb'
import styled, { css } from 'styled-components'
import FAQ from '../components/Check/elements/FAQ'

const Page = styled.div`
  ${(props) =>
    props.title === 'Algemene voorwaarden' &&
    css`
      & a {
        font-weight: ${props.theme.font.weight.xl};
        color: ${props.theme.color.text.contrast};
        text-decoration: underline;
      }
    `}
`

export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      ...FaqPageFrag
    }
  }
`

const PageTemplate = ({
  data: {
    page: { path, title, acf, yoast_meta: yoast },
  },
  pageContext,
}) => {
  return (
    <Layout>
      <SEO
        yoast={yoast}
        path={path}
        image={{
          url:
            acf.banner.image.localFile &&
            acf.banner.image.localFile.childImageSharp.openGraph.src,
        }}
        page="faq"
        questions={acf.questions}
      />

      <Hero small className="mb-lg-3" content={acf.banner} />

      <Breadcrumb data={title} className="py-2" pageContext={pageContext} />

      <Page title={title} className="container pt-5">
        <FAQ questions={acf.questions} />
      </Page>
    </Layout>
  )
}

export default PageTemplate
